import React from "react";
import { Alert, Container, Grid } from "@mui/material";
import "./Contact.css";
import contact from "../../asset/img/contact.svg";
import { useForm } from "@formspree/react";

const Contact = () => {
  const [state, handleSubmit] = useForm("xyyobnjz");

  return (
    <Container sx={{ mt: 15, mb: 10 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5} className="contactImg">
          <h2 style={{ marginTop: 22 }}>Contact</h2>
          <img src={contact} alt="" />
        </Grid>
        <Grid item xs={12} md={7} className="contactForm">
          <form onSubmit={handleSubmit}>
            <h2 className="formHeader">Any Query ?</h2>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="inputField"
                  name="name"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <input
                  type="number"
                  placeholder="Your Number"
                  className="inputField"
                  name="number"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <input
                  type="email"
                  placeholder="Your Email"
                  className="inputField"
                  name="email"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <input
                  type="text"
                  placeholder="Your Company Name"
                  className="inputField"
                  name="company"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <textarea
                  type="text"
                  rows="10"
                  style={{ width: "80%" }}
                  placeholder="Your Message"
                  className="inputField"
                  name="message"
                />
              </Grid>
            </Grid>
            <button type="submit" className="submitBtn">
              Submit
            </button>
          </form>
          {state.succeeded && (
            <Alert severity="success" sx={{ mt: 5 }}>
              Thank you for message, I will contact you soon
            </Alert>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
